<template>
    <div class="l-inner">
        <app-section
            :logo="true"
            :title="page.s1_title"
            :desc="page.s1_desc"
            :push="page.s1_push"
            :bgIntro="page.s1_bg_intro"
            :bgs="0"
        >
            <template #content>
                <div class="p-facts__grid -first | l-grid">
                    <template
                        v-for="(item, i) in page.s1_items"
                        v-if="!(i === 3 || i === 6)"
                    >
                        <div
                            v-if="(i === 2 || i === 5)"
                            :key="`col-1-${i}`"
                            class="l-grid__col || js-grid-col"
                        >
                            <template v-for="(subitem, i) in [item, page.s1_items[i+1]]">
                                <graph
                                    :key="`fact-graph-${i}`"
                                    v-if="subitem.slice_type === 'graph'"
                                    :title="subitem.primary.title"
                                    :desc="subitem.primary.desc"
                                    :svg="subitem.primary.svg"
                                />
                                <card-fact
                                    :key="`fact-card-${i}`"
                                    v-else
                                    :big="subitem.primary.big"
                                    :bg="subitem.primary.bg"
                                    :title="subitem.primary.title"
                                    :rounded="subitem.primary.rounded"
                                    :desc="subitem.primary.desc"
                                    :image="subitem.primary.image"
                                    :behind="subitem.primary.behind"
                                />
                            </template>
                        </div>
                        <graph
                            v-else-if="item.slice_type === 'graph'"
                            :key="`item-1-${i}`"
                            :title="item.primary.title"
                            :desc="item.primary.desc"
                            :svg="item.primary.svg"
                        />
                        <card-fact
                            v-else
                            :key="`item-1-${i}`"
                            :big="item.primary.big"
                            :bg="item.primary.bg"
                            :title="item.primary.title"
                            :rounded="item.primary.rounded"
                            :desc="item.primary.desc"
                            :image="item.primary.image"
                            :behind="item.primary.behind"
                        />
                    </template>
                </div>
            </template>
        </app-section>
        <app-section
            :logo="false"
            :title="page.s2_title"
            :desc="page.s2_desc"
            :push="page.s2_push"
            :bgIntro="page.s2_bg_intro"
            :bgs="2"
        >
            <template #content>
                <div class="p-facts__grid -second | l-grid">
                    <template
                        v-for="(item, i) in page.s2_items"
                        v-if="!(i === 2 || i === 6)"
                    >
                        <div
                            v-if="(i === 1 || i === 5)"
                            :key="`col-2-${i}`"
                            class="l-grid__col || js-grid-col"
                        >
                            <template v-for="(subitem, i) in [item, page.s2_items[i+1]]">
                                <graph
                                    :key="`fact-graph-2-${i}`"
                                    v-if="subitem.slice_type === 'graph'"
                                    :title="subitem.primary.title"
                                    :desc="subitem.primary.desc"
                                    :svg="subitem.primary.svg"
                                />
                                <card-fact
                                    :key="`fact-card-2-${i}`"
                                    v-else
                                    :big="subitem.primary.big"
                                    :bg="subitem.primary.bg"
                                    :title="subitem.primary.title"
                                    :rounded="subitem.primary.rounded"
                                    :desc="subitem.primary.desc"
                                    :image="subitem.primary.image"
                                    :behind="subitem.primary.behind"
                                />
                            </template>
                        </div>
                        <graph
                            v-else-if="item.slice_type === 'graph'"
                            :key="`item-1-${i}`"
                            :title="item.primary.title"
                            :desc="item.primary.desc"
                            :svg="item.primary.svg"
                        />
                        <card-fact
                            v-else
                            :key="`item-1-${i}`"
                            :big="item.primary.big"
                            :bg="item.primary.bg"
                            :title="item.primary.title"
                            :rounded="item.primary.rounded"
                            :desc="item.primary.desc"
                            :image="item.primary.image"
                            :behind="item.primary.behind"
                        />
                    </template>
                </div>
            </template>
        </app-section>
        <about />
        <push :page="page.page_push" />
    </div>
</template>

<script>

import Push from 'layout/Push';
import About from 'layout/About';
import AppSection from 'layout/AppSection';
import CardFact from 'objects/CardFact';
import AnimText from 'objects/AnimText';
import Graph from 'components/Graph';

import Variables from 'src/mixins/variables';

import debounce from 'lodash/debounce';

export default {
    name: 'Factes',
    components: {
        Push,
        About,
        AppSection,
        CardFact,
        AnimText,
        Graph,
    },
    mixins: [ Variables ],
    props: {
        page: Object,
    },
    data: () => ({
        $gridCols: [],
    }),
    mounted() {
        this.$gridCols = this.$el.querySelectorAll('.js-grid-col')

        this.setCols()

        // Window events
        window.addEventListener('resize', debounce(this.setCols, 100));
    },
    methods: {
        setCols() {
            let height
            this.$gridCols.forEach(($col) => {

                $col.classList.remove('-row')

                if(!this.isHorizontal) {
                    return
                }

                this.$parent.setScrollLength()

                // Set height to 0
                height = 0;

                Array.from($col.children).forEach(($item) => {
                    // Increment height
                    height += $item.offsetHeight
                })

                // Display column as row if children are higher than viewport height
                if(height > this.W.h) {
                    $col.classList.add('-row')
                }
            })
        },
        getComponent(item) {
            return item.slice_type === 'card' ? CardFact : Graph
        }
    },
};
</script>

<style lang="scss">


/*===================================
=            Facts grids            =
===================================*/

.p-facts__grid {

    &.-second {

        & ~ .l-section__bg {
            background-color: $color-dark;
        }
    }

    @media #{md("xs", "max")} {

        &.-first {

            > * {

                &:nth-child(1),
                &:nth-child(4),
                &:nth-child(6) {
                    margin-right: auto;
                }

                &:nth-child(2) {
                    margin-left: auto;
                }

                &:nth-child(3) {

                    > * {
                        //width: calc(100% - 15vw);

                        &:nth-child(1) { margin-right: auto; }
                        &:nth-child(2) { margin-left:  auto; }
                    }
                }

                &:nth-child(5) {
                    width: 100%;

                    > * {
                        &:nth-child(1) { margin-left: auto; }
                    }
                }
            }
        }
    }

    @media #{$breakpoint-vertical} {

        &.-second {

            > * {

                &:nth-child(1) {
                    order: 1;
                }

                &:nth-child(2) {
                    order: 2;
                }

                &:nth-child(3) {
                    order: 4;
                }

                &:nth-child(4) {
                    order: 3;

                    > *:nth-child(2) {
                        order: -1;
                    }
                }

                &:nth-child(5) {
                    order: 6;
                    align-self: flex-start;
                }

                &:nth-child(6) {
                    order: 5;
                    margin-top: 10vmin;
                }

                &:nth-child(7) {
                    order: 7;
                    margin-top: 1em;
                }
            }
        }
    }

    @media #{$breakpoint-horizontal} {

        &.-first {

            > * {

                &:nth-child(2),
                &:nth-child(3),
                &:nth-child(5) {
                    align-self: flex-start;
                }

                &:nth-child(2) {
                    margin-top: 0;
                }

                &:nth-child(3) {

                    > * {

                        &:nth-child(2) { padding-top: calc(#{vh(5)} + 2.5em); }
                    }
                }

                &:nth-child(4) {
                    margin-bottom: vh(10);
                }

                &:nth-child(6) {
                    margin-top: vh(10);
                }
            }
        }

        &.-second {

            & ~ .l-section__bg {

                &:nth-child(2) {
                    left: 6vw;
                    width: 30%;
                }

                &:nth-child(3) {
                    right: 0;
                    width: 20%;
                }
            }

            > * {

                &:nth-child(1) {
                    margin-bottom: vh(10);
                }

                &:nth-child(2) {
                    margin-right: 6vw;

                    .c-graph {
                        color: $color-light;
                    }
                }

                &:nth-child(3) {
                    margin-right: 10vw;
                }

                &:nth-child(6) {
                    margin-left: 10vw;
                }

                &:nth-child(2),
                &:nth-child(7) {
                    align-self: flex-end;
                }

                &:nth-child(3),
                &:nth-child(4),
                &:nth-child(5),
                &:nth-child(6) {
                    align-self: flex-start;
                }
            }
        }
    }
}

</style>
